import { render, staticRenderFns } from "./AppCompatibility.vue?vue&type=template&id=2f369c77&"
import script from "./AppCompatibility.vue?vue&type=script&lang=js&"
export * from "./AppCompatibility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports